/** @format */

module.exports = [
  {
    name: "bank-login",
    title: "DE Flow using Bank Login",
  },
  {
    name: "no-bank-login",
    title: "DE Flow w/o Bank Login",
  },
  {
    name: "bank-login-standalone",
    title: "DE Flow using Bank Login for existing customers",
  },
  {
    name: "bank-login-ocr",
    title: "DE Flow using Bank Login + OCR",
  },
  {
    name: "verify",
    title: "Regily Verify",
  },
];



// WEBPACK FOOTER //
// ./src/partners/config/variants.js